import { theme } from "uikit";

import Order, {
	OrderReminderStatus,
} from "../../../../../../../services/Order";

const backgroundColorByStatus = {
	offer: "#51C3F7",
	executing: "rgb(76, 175, 80)",
	inactive: "#ebebeb",
	send: "#FFA500",
	dispatcherBGC: theme.colors.disabled_text,
	dispatcherText: theme.colors.white,
};

const cellProcessing = (
	item?: Order.Model,
	options?: { offerExpired?: boolean },
) => {
	if (!item)
		return {
			content: "",
			backgroundColor: undefined,
			textColor: undefined,
		};

	// Истёкший оффер для ячейки равен отсутствующему: иначе синий позывной
	// висит до прихода серверного `offer: null`.
	const offer = options?.offerExpired ? undefined : item.offer;

	const lastReceivedOrder =
		item?.additionalFields?.transfer?.lastReceivedOrder;

	const executorsFromTransfer = Array.isArray(
		lastReceivedOrder?.executorToOrder,
	)
		? lastReceivedOrder?.executorToOrder ?? []
		: [];

	const executorFromTransfer =
		lastReceivedOrder?.executorToOrder?.[0]?.executor ??
		lastReceivedOrder?.offer?.executor;

	const executor = item?.executorToOrder?.[0]?.executor ?? offer?.executor;

	const isOwn = item?.isOwn;

	const content =
		isOwn && executorFromTransfer ? "" : executor?.callSign ?? "";

	const isDispatcher = item.executorToOrder?.some(
		(e) =>
			e.executor?.id === executor?.id &&
			e.additionalFields?.acceptedByDispatcher?.active,
	);

	const isDispatcherFrom = executorsFromTransfer.some(
		(e) =>
			e.executor?.id === executorFromTransfer?.id &&
			e.additionalFields?.acceptedByDispatcher?.active,
	);

	let backgroundColor: string | undefined;
	if (lastReceivedOrder && isOwn && executorFromTransfer) {
		backgroundColor = undefined;
	} else if (
		item.executorReminderStatus?.status === OrderReminderStatus.SEND
	) {
		backgroundColor = backgroundColorByStatus.send;
	} else if (item.executingStages?.accepted) {
		backgroundColor = backgroundColorByStatus.executing;
	} else if (
		isDispatcher &&
		(item.executingStages?.assigned || !offer?.executor?.online) &&
		!item.executingStages?.accepted
	) {
		backgroundColor = backgroundColorByStatus.dispatcherBGC;
	} else if (item.executingStages?.assigned) {
		backgroundColor = backgroundColorByStatus.inactive;
	} else if (offer) {
		backgroundColor = offer.executor?.online
			? backgroundColorByStatus.offer
			: backgroundColorByStatus.inactive;
	}

	let textColor: string | undefined;
	if (isDispatcherFrom && lastReceivedOrder && isOwn) {
		textColor = undefined;
	} else if (
		isDispatcher &&
		(item.executingStages?.assigned || !offer?.executor?.online)
	) {
		textColor = theme.colors.white;
	}

	return { content, backgroundColor, textColor };
};

export default cellProcessing;
